export default __webpack_public_path__ + "static/mine-free_cover-small_1-21ab872abc8834dcab205579a5ab3e76.png";